/**
 * Wie hoch der Rahmen einer langen Tabelle werden darf (HJ-041).
 *
 * Die Leiste zum Seitwärts-Scrollen sitzt am unteren Rand des Rahmens. Reichte
 * er über das Fenster hinaus, sah man sie erst nach dem Scrollen bis zur letzten
 * Zeile — bei achtzig Touren also nie, wenn man sie braucht.
 *
 * Warum gerechnet und nicht `calc(100vh - …)` im CSS: Was über der Tabelle steht,
 * wechselt. Das Formular „Neue Tour" und die Rückfrage gehen auf und zu, die
 * Vorausschau ist mal da und mal nicht. Eine feste Zahl stimmt für genau einen
 * dieser Zustände.
 *
 * Eigene Datei ohne React, damit `npm run logik` sie prüfen kann.
 */

/** Kopf, Filter, Leiste und gut zwei Zeilen. */
export const MINDESTHOEHE = 200;

/** Luft zwischen Rahmen und Fensterrand, damit die Leiste nicht am Rand klebt. */
export const UNTERER_ABSTAND = 16;

/**
 * Die Höhe, die der Rahmen höchstens haben darf.
 *
 * Beginnt er im Fenster, endet er am Fensterende, aber nie unter der Mindesthöhe.
 * Ohne Sprung: Erst sprang er unterhalb einer Grenze auf volle Fensterhöhe, und
 * schon der erste Filter, der ihn ein paar Pixel nach unten schob, brachte die
 * Leiste wieder unter den Fensterrand (Review PR #19). Sehr tief im Fenster ragt die
 * Mindesthöhe nun etwas darüber hinaus; die Leiste ist dann eine kurze Scrollbewegung
 * entfernt und nicht die ganze Fensterhöhe.
 *
 * Beginnt er unterhalb des Fensters (offenes Formular darüber), ist ohnehin nichts
 * von ihm zu sehen. Dann darf er ein Fenster hoch sein: Wer hinscrollt, hat ihn samt
 * Leiste vollständig im Blick.
 */
export function rahmenhoehe(fensterhoehe: number, oberkanteImDokument: number): number {
  if (oberkanteImDokument >= fensterhoehe) {
    return Math.max(MINDESTHOEHE, fensterhoehe - 2 * UNTERER_ABSTAND);
  }
  return Math.max(MINDESTHOEHE, fensterhoehe - oberkanteImDokument - UNTERER_ABSTAND);
}
